import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {SplitText} from 'gsap/SplitText';
import {CustomEase} from 'gsap/CustomEase';

export default class Reveal {
    constructor(element) {
        if (!element) return;

        this.element = element;

        if (element.getAttribute('data-reveal') === 'headings') {
            this.headingAnimation();
        }
    }

    headingAnimation() {
        document.fonts.ready.then(() => {
            gsap.registerPlugin(SplitText);
            gsap.registerPlugin(ScrollTrigger);
            const split = new SplitText(this.element, {type: 'words'});

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: this.element.closest('.pane'),
                    start: 'top 70%',
                    bottom: 'bottom top',
                    once: true,
                    stagger: 0.5,
                    markers: false,
                },
            });

            tl.fromTo(split.words, {
                yPercent: 100,
                opacity: 0,
            }, {
                yPercent: 0,
                opacity: 1,
                stagger: 0.1,
                duration: 1.5,
                delay: 0.1,
                ease: CustomEase.create('custom', '0.22, 1.00, 0.36, 1.00'),
            });
        });
    }

}
